export function getDataForPatientCase(considerPanels, clinicMode?) {
    return {
        format: "json",
        payload: JSON.stringify({
            considerPanels: considerPanels,
            clinicMode,
            createdAt: new Date()
        }),
    };
}

